export default {
  tips: {
    mulStart:
      'ユーザージャーニーの開始地点は1つのみ設定可能です。現在は複数存在しています。',
    ignoreAfterInstall:
      'ユーザーが移動後25秒以内に戻らない場合、移動後のイベントは分析データに含まれません.',
    greenPath: 'GreenPath',
    greenPathDesc:
      '{greenPath}はジャーニー中の最大のフローブランチであり、このパスを基に最適化の解を探索するか、さらに試してみることをお勧めします。',
    flowsCount:
      '1つのトラッキングポイントから複数のブランチが到達できる場合、最大のフローブランチはユーザー数が最も多いブランチを指します。',
    dataAnomaly:
      'ネットワークの遅延などの要因により、データには極めて小さな割合の異常が存在する可能性があります。データを分析する際には、全体的なトレンドや割合により焦点を当て、これらの小さなエラーは無視することが推奨されます。',
    emptyNode:
      'このクリエイティブはカスタムトラッキングポイントが設定されていません。',
  },
  fields: {
    flows: '閉じる',
    duration: '所要時間',
    reach: 'セッション',
    flowsNext: '閉じて次へ進む',
    loss: '離脱',
    install: 'リダイレクト',
  },
  basicAction: {
    imp: 'インプレッション',
    gs: 'プレイアブルインプレッション',
    ws: 'ウェブビュー表示',
  },
  actionBar: {
    exitFullScreen: 'フルスクリーンを閉じる',
    FullScreen: 'フルスクリーン',
    adjustStage: 'キャンバスに合わせる',
  },
  projectFilter: {
    journey: {
      emptyData:
        '現在のプロジェクトにトラッキングポイントがなく、使用可能な別のプロジェクトが自動選択されました。',
    },
    scene: {
      emptyData:
        '現在のプロジェクトではシナリオが分割されていないため、使用可能な別のシナリオが自動的に選択されました。',
    },
    template_name: 'プレイアブルテンプレート',
    template_name_id: 'プレイアブルテンプレートID',
    c_template_name: 'クリエイティブコンセプト',
    c_template_name_id: 'クリエイティブコンセプトのID',
    basic_id: 'クリエイティブID',
    mws_creative_name: 'クリエイティブ名',
  },
}
